import React, {useState} from "react";
import { useJobData } from "../../hooks/useJobData";
import Form from "./Form";
import {getDataFresh} from "../../state/selectors";
import { useSelector } from "react-redux";
import {useDefaultsData} from "../../hooks/useDefaultsData";
import {useUtilData} from "../../hooks/useUtilData";
import useDefaultWorkLookupData from "../../hooks/useDefaultWorkLookupData";
import Nav from "../Nav/Nav"
import {useParams} from "react-router-dom";
import {ToastContainer} from "react-toastify";

function JobForm(props) {
  let dataFresh = useSelector(getDataFresh);
  let app_defaults_loaded = useDefaultsData({});
  let {job} =  useParams();
  let job_loaded = useJobData(job, dataFresh);
  const [utilsParam, setUtilsParam] = useState({department: 1, key: 1, work_type: 1, movement_rate: 1, movement_type: 1, driver: 1, tracking: 1, fitter: 1})
  let utilsLoaded = useUtilData(utilsParam);
  let defaultWorkLoaded = useDefaultWorkLookupData({});
  //let departmentsLoaded = useDepartmentsData({});
  //let keys_loaded = useKeysData({});
  //let workTypesLoaded = useWorkTypeData({})
  //let movementRatesLoaded = useMovementsRateData({});
  //let movementTypesLoaded = useMovementTypesData({});
  //let driversLoaded = useDriversData({});
  //let trackingOptionsLoaded = useTrackingOptionsData({});
  //const fittersLoaded = useFittersData({page_size:1000})

  //loaded={job_loaded && departmentsLoaded && fittersLoaded && keys_loaded && workTypesLoaded && movementRatesLoaded && movementTypesLoaded && driversLoaded && trackingOptionsLoaded}
  return (
      <div>
        <Nav/>
    <Form
      loaded={job_loaded && utilsLoaded && app_defaults_loaded && defaultWorkLoaded}
      endpoint={props.endpoint}
      history={props.history}
      utilsParam={utilsParam}
      setUtilsParam={setUtilsParam}
    />
      </div>
  );
}

export default JobForm;
